module.exports = __webpack_public_path__ + "img/32.e8ebd41b.jpg";